/**
 * Token refresh notifications.
 *
 * The interceptors renew the access token on their own, so the auth provider
 * never sees it happen. Listeners registered here run after each successful
 * refresh, which lets the provider re-read the user and pick up feature flag
 * changes.
 */

type TokenRefreshListener = () => void;

const listeners = new Set<TokenRefreshListener>();

/** Register a listener for successful token refreshes. Returns an unsubscribe function. */
export function onTokenRefreshed(listener: TokenRefreshListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Tell every listener that a new access token was stored. */
export function notifyTokenRefreshed(): void {
  for (const listener of [...listeners]) {
    try {
      listener();
    } catch (error) {
      console.warn('[api-client] Token refresh listener failed', error);
    }
  }
}
